import { render, staticRenderFns } from "./RecipeBook.vue?vue&type=template&id=9644ba26&scoped=true&"
import script from "./RecipeBook.vue?vue&type=script&lang=js&"
export * from "./RecipeBook.vue?vue&type=script&lang=js&"
import style0 from "./RecipeBook.vue?vue&type=style&index=0&id=9644ba26&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9644ba26",
  null
  
)

export default component.exports